<!-- <body>
        <div class="container-fluid jumbotron mt-5">
                <div class="container bg-transparent">
                <div class="mt-5"></div>
                        <div class="mb-5">
                                <div [innerHTML] = "announcement.description"></div>
                        </div>
                </div>
        </div>                
</body> -->
 

<!-- carousel -->
<!-- <div class="carousel-container" *ngIf="announcements.length">
  <div class="announcement" [@fade] *ngIf="announcements[currentIndex]">
    <div class="text-center" [innerHTML] = "announcements[currentIndex].description"></div>
  </div>

  <div class="dots"  *ngIf="announcements.length > 1">
    <span
      *ngFor="let a of announcements; index as i"
      (click)="goTo(i)"
      [class.active]="i === currentIndex"
    ></span>
  </div>
</div> -->


<!-- rotating bar -->
<div *ngIf="announcements" class="rotating-bar-wrapper">
  <div class="rotating-bar-text" [style.animation-duration]="25 + 's'">
    <!-- <span *ngFor="let announcement of announcements">
      • {{ announcement.description }} &nbsp;&nbsp;&nbsp;
    </span> -->
    <span *ngFor="let announcement of announcements" [innerHTML] = "announcement.description">
       &nbsp;&nbsp;&nbsp;
    </span>    
  </div>
</div>